import { Box, Card, Container } from "@material-ui/core";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import React, { useState } from "react";

import AddEmailSettings from "../../components/AddEmailSettings";
import EventButton from "../../components/EventButton";
import EventEmptyView from "../../components/EventEmptyView";
import EventEntityDrawer from "../../components/EventEntityDrawer";
import EventEntityTable from "../../components/EventEntityTable";
import EventSectionSubTitle from "../../components/EventSectionSubTitle";
import EventSectionTitle from "../../components/EventSectionTitle";
import ModalValidation from "../../components/ModalValidate";
// ...
import Page from "../../components/Page";
import useAttendees from "../../hooks/useAttendees";
import AddAttendee from "./components/AddAttendee";
import AttendeeInvDate from "./components/InvDate";
import AttendeeStatus from "./components/Status";
import { TABLE_HEAD } from "./config";

const EventAttendee = () => {
  const isMobile = useMediaQuery("(max-width:850px)");
  const [delModal, setDelModal] = useState({
    open: false,
    id: null,
    label: "",
  });
  // ...
  const { isLoading, data: attendees, onUpdate, onRemove } = useAttendees();
  // ...
  const [drawer, setDrawer] = useState({ open: false, data: {}, idx: "" });
  const [drawerEmail, setDrawerEmail] = useState({ open: false });
  const attendeesList = attendees.map((a) => ({
    ...a,
    name: a?.custom.name || "",
    inviteDateLabel: <AttendeeInvDate date={a.inviteDate} />,
    statusLabel: <AttendeeStatus val={a.invitationStatus} />,
  }));
  // ...
  const onEditAttendee = async (data) => {
    await onUpdate(data);
    setDrawer({ open: false, data: {}, idx: "" });
  };
  const onDeleteAttendee = async (id) => {
    await onRemove(id);
    // ...
    setDelModal({ open: false, id: null, label: "" });
  };
  // ...
  return (
    <Page title="Manage Attendees">
      <Container>
        <Box>
          <EventSectionTitle
            title="Event attendees"
            subTitle="Invite and manage people"
            src="/static/setup/title/attendees.svg"
          />

          {attendeesList.length > 0 && (
            <EventSectionTitle
              title="View attendees list"
              subTitle="Review and invite people "
              sx={{ marginBottom: "30px !important" }}
            >
              <EventButton
                isLoading={isLoading}
                handler={() => setDrawer({ open: true, _id: null })}
              >
                {isMobile && "Invite"}
                {!isMobile && "Invite people"}
              </EventButton>
            </EventSectionTitle>
          )}

          {attendeesList.length > 0 && (
            <EventSectionSubTitle>
              <EventButton
                emails
                handler={() => setDrawerEmail({ open: true })}
              >
                Email invitation settings
              </EventButton>
            </EventSectionSubTitle>
          )}

          {attendeesList.length === 0 && (
            <EventEmptyView
              src="/static/setup/empty/attendees.svg"
              title="Invite people"
              desc="Send customized invitation and manage attendees lists"
              btnLabel="Invite people"
              handler={() => setDrawer({ open: true, data: {}, idx: "" })}
              isLoading={isLoading}
            />
          )}

          {attendeesList.length > 0 && (
            <Box>
              <Card>
                <EventEntityTable
                  noEdit
                  label="attendee"
                  head={TABLE_HEAD}
                  data={attendeesList}
                  // onEditHandler={(data, idx) =>
                  //   setDrawer({ open: true, data, idx })
                  // }
                  onDeleteHandler={(data) => {
                    setDelModal({
                      open: true,
                      id: data.id,
                      label: data?.name,
                    });
                  }}
                />
              </Card>
            </Box>
          )}
        </Box>

        <EventEntityDrawer
          open={drawer.open}
          closeDrawer={() => setDrawer({ open: false, data: {}, idx: "" })}
          title="Add new attendee"
          sub="Enter attendee details"
          width="490px"
        >
          <AddAttendee
            idx={drawer.idx}
            data={drawer.data}
            onEditAttendee={onEditAttendee}
            // ...
            attendees={attendees?.map((a) => a?.email)}
            isLoading={isLoading}
          />
        </EventEntityDrawer>

        <EventEntityDrawer
          open={drawerEmail.open}
          closeDrawer={() => setDrawerEmail({ open: false, _id: null })}
          title="Email invitation settings"
          sub="Configure email invitation dates and templates"
        >
          <AddEmailSettings onSetEmailSettings={() => {}} />
        </EventEntityDrawer>
      </Container>

      <ModalValidation
        open={delModal.open}
        title="Delete sponsor"
        isLoading={isLoading}
        // ...
        yes={{
          label: "delete",
          handler: () => onDeleteAttendee(delModal.id),
        }}
        no={{
          label: "cancel",
          handler: () => setDelModal({ open: false, id: null, label: "" }),
        }}
      >
        Are you sure to delete {delModal?.label || "attendee"}?
      </ModalValidation>
    </Page>
  );
};

export default EventAttendee;
